import { addHours, getMinutes, startOfHour } from 'date-fns';

export const roundToNearestHour = (date: Date): Date => {
  const minutes = getMinutes(date);

  if (minutes >= 30) {
    return startOfHour(addHours(date, 1));
  }

  return startOfHour(date);
};

export const startOfDayInUtc = (date: Date): Date =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
